import { render, staticRenderFns } from "./SignUpDialog.vue?vue&type=template&id=72f35ebd&scoped=true&lang=pug"
import script from "./SignUpDialog.vue?vue&type=script&lang=js"
export * from "./SignUpDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f35ebd",
  null
  
)

export default component.exports